import { Directive, Input, OnChanges, TemplateRef, ViewContainerRef } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Observable, of } from 'rxjs';
import {
  PermissionAction,
  PermissionResource,
  buildPermissionCode,
} from 'src/app/core/constants/permissions.constants';
import { PermissionService } from 'src/app/core/services/permission.service';

@UntilDestroy()
@Directive({ selector: '[appHasPermission]' })
export class HasPermissionDirective implements OnChanges {
  @Input() appHasPermission: PermissionResource | string | string[] | null = null;
  @Input() appHasPermissionAction: PermissionAction = PermissionAction.Read;

  private hasView = false;

  constructor(
    private readonly templateRef: TemplateRef<unknown>,
    private readonly viewContainer: ViewContainerRef,
    private readonly permissionService: PermissionService,
  ) {}

  ngOnChanges(): void {
    this.getAllowed$()
      .pipe(untilDestroyed(this))
      .subscribe((allowed) => this.updateView(allowed));
  }

  private getAllowed$(): Observable<boolean> {
    if (!this.appHasPermission) {
      return of(true);
    }

    if (Array.isArray(this.appHasPermission)) {
      return this.permissionService.hasAnyPermission$(this.appHasPermission);
    }

    if (this.appHasPermissionAction === PermissionAction.Read) {
      return this.permissionService.canRead$(this.appHasPermission as PermissionResource);
    }

    return this.permissionService.hasPermission$(
      buildPermissionCode(this.appHasPermission, this.appHasPermissionAction),
    );
  }

  private updateView(allowed: boolean): void {
    if (allowed && !this.hasView) {
      this.viewContainer.createEmbeddedView(this.templateRef);
      this.hasView = true;
      return;
    }

    if (!allowed && this.hasView) {
      this.viewContainer.clear();
      this.hasView = false;
    }
  }
}